import { Component } from '@angular/core';
import { NotificationService } from '../common/component/notification/notification.service';
import { HomeService } from './home.service';
import { MasterDataService } from "../common/service/master-data.service";
import { SharedService } from "../services/SharedService";

@Component({
    templateUrl: 'home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent {

    homePageData: any;
    isLoadPanelVisible: boolean = true;

    constructor(private homeService: HomeService,
        private masterDataSvc: MasterDataService,
        private SharedSvc: SharedService,
        private notificationService: NotificationService) {
        this.SharedSvc.disableSideMenu = true;
        this.get();
        this.getUserRoles();
    }

    get() {
        this.homeService.get().subscribe({
            next: homePageData => {
                this.homePageData = homePageData[0];
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching Home Page data", error);
            }
        });
    }

    getUserRoles() {
        this.masterDataSvc.getUserRoles().subscribe({
            next: data => {
                if (data && data.length > 0) {
                    this.SharedSvc.disableSideMenu = false;
                    this.SharedSvc.UserRoles = data[0];
                    this.isLoadPanelVisible = false;
                }
            },
            error: (error) => {
                this.notificationService.alert("error", "Error while fetching User Roles", error);
                this.isLoadPanelVisible = false;
            }
        })
    }

}
